
import React from 'react';
import './Badge.css';

type Variant = 'default' | 'success' | 'warning' | 'danger' | 'purple' | 'ocean';

interface Props {
  children: React.ReactNode;
  variant?: Variant;
}

export default function Badge({ children, variant = 'default' }: Props) {
  return <span className={`badge badge--${variant}`}>{children}</span>;
}
